import {format} from 'date-fns';
import {v4 as uuidv4} from 'uuid';
import {requestContext} from '../common/requestContext';
import {LOG_DATETIME_FORMAT, LogType} from './constant';
import {sseClients} from './sseClients';

export function sendSseLog({
  type,
  message,
}: {
  type: LogType;
  message: string | Record<string, unknown>;
}) {
  if (sseClients.length === 0) {
    return;
  }
  const logObj = {
    id: uuidv4(),
    type,
    time: format(new Date(), LOG_DATETIME_FORMAT),
    message,
    requestId: requestContext?.requestInfo?.requestId,
    clientId: requestContext?.requestInfo?.deviceId,
  };
  const logStr = JSON.stringify(logObj);
  sseClients.forEach(client => {
    client.res.write('data: ' + logStr + '\n\n');
  });
}
